import React from 'react';
import PropTypes from 'prop-types';

import './EditButton.scss';
import SVGFromCloudinary from '../../../../Elements/SVGFromCloudinary/SVGFromCloudinary';

const EditButton = ({ className = '', handleClick = () => {} }) => (
    <button
        className={`component-Users-UserProfile-Modules-EditButton ${className}`}
        type="button"
        aria-label="Edit"
        onClick={handleClick}
    >
        <SVGFromCloudinary
            cloudinaryID={'v1591579243/icons/edit-button-active.svg'}
        />
    </button>
);

EditButton.propTypes = {
    /**
     * text to be displayed
     */
    className: PropTypes.string,
    /**
     * handler for clicking
     */
    handleClick: PropTypes.func,
};

export default EditButton;
